module.exports = __webpack_public_path__ + "assets/img/4b5ce7498a9fec86d6ffcb2092ed2155.svg";